import React, { useState } from 'react';
import axios from 'axios';
import { Alert, Modal, ModalHeader, ModalBody, ModalFooter, Button, CustomInput } from 'reactstrap';
import { getCookie } from '../jwt/_helpers/cookie';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import './flaggedContent.css';

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const EscrowPaymentModal = ({
  modalOpen,
  setModalOpen,
  toggleModal,
  id,
  name,
  flagged_tracks,
  escrow_payment_declined,
  forceUpdate,
  setForceUpdate,
  openDistributeModal=false,
  setOpenDistributeModal,
  isDisabled,
}) => {
  const tokenAPI = getCookie("token");
  const { t } = useTranslation();
  const options = {
    method: "POST",
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${tokenAPI}`,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json"
    }
  };

  const [isProcessing, setIsProcessing] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [success, setSuccess] = useState(false);
  const [escrowPaymentAccepted, escrowPaymentAcceptedSET] = useState(false);
  const [escrowPaymentDeclined, escrowPaymentDeclinedSET] = useState(escrow_payment_declined);

  const handleEscrowPaymentDeclarationChange = (action) => {
    if (action === "accept") {
      escrowPaymentAcceptedSET(true);
      escrowPaymentDeclinedSET(false);
    } else {
      escrowPaymentAcceptedSET(false);
      escrowPaymentDeclinedSET(true);
    }
  }

  const proceed = () => {
    if(escrowPaymentAccepted) {
      handlePayment();
    } else {
      handleRejectPayment();
    }
  };

  const handlePayment = async () => {
    setIsProcessing(true);
    setIsCompleted(false);
    try {
      const response = await axios.post(`${API_URL}process-flagged-tracks-payment/`, {"release_id": id}, options);
  
      if (response.status === 200 || response.status === 201) {
        let data = response.data;
        if (data && data.checkout_url) {
          window.location.href = data.checkout_url;
        }
      } else {
        console.error("Error occurred during payment");
      }
    } catch (error) {
      setIsProcessing(false);
      console.error("Error occurred during payment:", error);
    }
  };

  const handleRejectPayment = async () => {
    axios({
      method: "patch",
      mode: 'cors',
      url: `${API_URL}releases/${id}/`,
      data:{
        "escrow_payment_declined": true,
      },
      headers: {
        Authorization: `Bearer ${tokenAPI}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      if (response.status === 200) {
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          setModalOpen(false);
          if(openDistributeModal) {
            setOpenDistributeModal(true);
          } else {
            setForceUpdate(forceUpdate + 1);
          }
        }, (2000));
      }
    });
  };  

  const tracksMap = flagged_tracks ?? {};
  const nonWhitelistedTracksCount = Object
    .values(tracksMap)
    .filter(track => !track.is_light_whitelisted)
    .length;
  const totalAmount = nonWhitelistedTracksCount * 15;

  return (
    <div>
      <Modal isOpen={modalOpen} toggle={toggleModal} className="modal-lg">
        <ModalHeader toggle={toggleModal}>{(!isCompleted && !isProcessing)? t("flaggedContent.view.form.modal.header.titleFlaggedTracksDetails"): t("flaggedContent.view.form.modal.header.titleFlaggedTrackPayment")}</ModalHeader>
        <ModalBody>
          {
            (!isCompleted && !isProcessing) && 
            <>
              <div className="mb-3">
                {t("flaggedContent.view.form.modal.body.table.title")}
              </div>

              {flagged_tracks && Object.keys(flagged_tracks).length > 0 && (
                <table className="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{t("flaggedContent.view.form.modal.body.table.column.name")}</th>
                      <th>{t("flaggedContent.view.form.modal.body.table.column.flaggedArtist")}</th>
                      <th>{t("flaggedContent.view.form.modal.body.table.column.payableAmount")}</th>
                      <th>{t("flaggedContent.view.form.modal.body.table.column.paymentStatus")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.values(flagged_tracks).map((track, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{track.name}</td>
                        <td>
                          <>
                            {Object.values(track.artists).map((artist, artistIndex) => {
                                let artistDetailsLink = `/artists/${artist.id}/view-details`;                              
                                return (
                                  <span key={artistIndex}>
                                    <Link
                                      to={artistDetailsLink}
                                      style={{
                                        cursor: 'pointer',
                                        color: '#000a60',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      {artist.name}{artistIndex < track.artists.length - 1 && ', '}
                                    </Link>
                                  </span>
                                )
                              })
                            }
                          </>
                        </td>
                        <td><b>{t("flaggedContent.view.form.modal.body.table.label.payableAmount")}</b></td>
                        <td>
                          {
                            track.is_light_whitelisted? <b className={"text-success"}>{t("flaggedContent.view.form.modal.body.table.label.paid")}</b> : <b className={"text-danger"}>{t("flaggedContent.view.form.modal.body.table.label.pending")}</b>                            
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              <div className="mt-4 mb-4">
                <Trans i18nKey="flaggedContent.view.form.modal.body.message.totalPayableAmount" values={{ totalAmount }}>
                  To complete the delivery of your release to <strong>Spotify</strong>, a refundable deposit of <strong>{totalAmount} €</strong> is required. Please accept the terms below and click <strong>Proceed</strong> button to make your payment.
                </Trans>
                <br/><br/>

                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <CustomInput
                    type="checkbox"
                    id="escrowPaymentAccepted"
                    name="escrowPaymentAccepted"
                    checked={escrowPaymentAccepted}
                    value={escrowPaymentAccepted}
                    disabled={isDisabled}
                    onChange={(e) => { handleEscrowPaymentDeclarationChange("accept") }}
                  />
                  <div>
                    <Trans i18nKey="flaggedContent.view.form.modal.body.message.escrowAmountAgreement" values={{ totalAmount }}>
                      I accept and acknowledge that an escrow amount of <strong>{totalAmount} €</strong> will be deposited by me. This amount will be held till the <strong>end of subscription</strong> and, provided no issues arise, will be returned to me at the end of this period. However, if I violate the terms of this agreement during this time, the escrow amount will be applied to the outstanding invoice and will not be refunded. By proceeding, I affirm my understanding and acceptance of these conditions.
                    </Trans>
                  </div>
                </div>

                <br/>

                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <CustomInput
                    type="checkbox"
                    id="escrowPaymentDeclined"
                    name="escrowPaymentDeclined"
                    checked={escrowPaymentDeclined}
                    value={escrowPaymentDeclined}
                    disabled={isDisabled}
                    onChange={(e) => { handleEscrowPaymentDeclarationChange("reject") }}
                  />
                  <div>
                    <Trans i18nKey="flaggedContent.view.form.modal.body.message.escrowPaymentRejected" values={{ releaseName: name }}>
                      I do not accept the escrow payment terms and, accordingly, acknowledge that my release <strong>{name}</strong> will <strong>not be distributed to Spotify</strong>.
                    </Trans>
                  </div>
                </div>
                <br/>
              </div>
            </>
          }
          <div className="payment-animation">
            {isProcessing && (
              <div className="spinner-container">
                <div className="spinner"></div>
                <div className="processing-text">{t("flaggedContent.view.form.modal.body.label.processingPayment")}</div>
              </div>
            )}

            {isCompleted && (
              <div className="success-container">
                <div className="success-checkmark">
                  <div className="check-icon">
                    <div className="icon-circle"></div>
                    <div className="mdi mdi-check mdi-48px"></div>
                  </div>
                </div>
                <div className="success-text">{t("flaggedContent.view.form.modal.body.label.paymentSuccessful")}</div>
              </div>
            )}

            {
              success && <Alert color="success">
                {t("flaggedContent.view.form.modal.body.message.consentRecordedSuccessfully")}
              </Alert>
            }
          </div>
        </ModalBody>
        <ModalFooter>
          {
            !isCompleted && !isProcessing && <>
              <Button color="success" onClick={proceed} disabled={isProcessing || (!escrowPaymentAccepted && !escrowPaymentDeclined) || (escrow_payment_declined && escrow_payment_declined === escrowPaymentDeclined) || success || isDisabled}>
                {t("flaggedContent.view.form.modal.button.proceed")}
              </Button>
            </>
          }
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default EscrowPaymentModal;